import { useQuery } from '@tanstack/react-query';
import { apiService } from '../utils/serviceApi';

const fetchDriveoffStatsByLabel = async (market, selectedGSZIds) => {
  const response = await apiService.post(
    `${process.env.REACT_APP_SERVICE_URL}/api/dashboard/gas-station-ranking-table-data/by-label`,
    {
      market,
      selectedGSZIds,
    }
  );
  return response.data;
};

export const useDriveoffStatsByLabel = ({ market, selectedGSZIds, enabled = true }) => {
  return useQuery({
    queryKey: ['driveoffStatsByLabel', market, selectedGSZIds],
    queryFn: () => fetchDriveoffStatsByLabel(market, selectedGSZIds),
    enabled: enabled && Array.isArray(selectedGSZIds) && selectedGSZIds.length > 0,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
